module.exports = __webpack_public_path__ + "img/inactive-icon.6dded2e5.svg";